var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoEmbed",staticStyle:{"text-align":"center"}},[_c('video',{staticClass:"courseItemVid",attrs:{"autoplay":"autoplay","playsinline":"","height":"349","width":"560"}},[_c('source',{attrs:{"src":"","type":"video/mp4"}}),_vm._v(" Your browser does not support the video tag. ")])])
}]

export { render, staticRenderFns }